import request from './request'
import { AccountantCurrentUser } from '../../types'

export interface AccountantUpdateParams {
  first_name?: string
  last_name?: string
  company_name?: string
  locale?: string
  current_password?: string
  password?: string
}

export default class MeController {
  static update(accountant: AccountantUpdateParams): Promise<AccountantCurrentUser & { errors?: { field: string, message: string }[] }> {
    return request('/api/me', { method: 'PATCH', body: { accountant } })
  }
}
